const purchase = {
  code: "供應商編碼",
  name: "供應商名稱",
  shortName: "供應商簡稱",
  country: "國籍/區域",
  address: "地址",
  zipCode: "郵政編碼",
  email: "Email地址",
  contact: "聯絡人",
  phone: "電話",
  fax: "傳真",
  mobile: "手機",
  account1: "開戶銀行1",
  bank1: "銀行賬號1",
  swiftCode1: "銀行編碼1",
  account2: "開戶銀行2",
  bank2: "銀行賬號2",
  swiftCode2: "銀行編碼2",
  creditLevel: "信用等級",
  creditLine: "信用額度",
  depositRate: "訂金比例(%)",
  tradeTerm: "貿易條款",
  payMethod: "付款方式",
  affiliates: "關聯公司",
  org: "分管部門",
  taxRate: "稅率（%）",
  taxRate1: "稅率",
  billingDays: "帳期(天)",
  principal: "委託方",
  relatedDocuments: "相關資料(合同/營業執照/開票資料)",
  price: "價格",
  plCode: "請輸入供應商編碼",
  plName: "請輸入供應商名稱",
  plShortName: "請輸入供應商簡稱",
  plAddress: "請輸入供應商地址",
  plZipCode: "請輸入供應商郵政編碼",
  plEmail: "請輸入供應商Email地址",
  plContact: "請輸入聯絡人",
  plPhone: "請輸入供應商電話",
  plFax: "請輸入供應商傳真",
  plMobile: "請輸入供應商手機號",
  plBank1: "請輸入銀行賬號1",
  plAccount1: "請輸入開戶銀行1",
  plSwiftCode1: "請輸入銀行編碼1",
  plBank2: "請輸入銀行賬號2",
  plAccount2: "請輸入開戶銀行2",
  plSwiftCode2: "請輸入銀行編碼2",
  plCreditLine: "請輸入信用額度",
  plDepositRate: "請輸入訂金比例",
  plTradeTerms: "請選擇貿易條款",
  plPaymentMethod: "請選擇付款方式",
  plAffiliates: "請輸入關聯公司",
  plTaxRate: "請輸入稅率",
  plBillingDays: "請輸入帳期",
  plPrincipal: "請輸入委託方",
  wmsApi: "供應商API",
  plWmsApi: "請輸入供應商API",
  customerList: "供應商列表",
  addCustomer: "添加供應商",
  documents: "相關資料",
  codeExisted: '供應商編碼已存在',
  supplierNotExisted: "供應商不存在",
  stPrice: '含稅單價',
  priceExisted: '當前商品已有價格，無需重新添加',
  product: "商品",
  plPrice: "請輸入含稅單價",
  expiredAt: '過期時間',
  plExpiredAt: '請選擇過期時間',
  priceExpiredAt: '有效期',
  days: '供貨週期',
  plDays: '請輸入供貨週期',
  mpq: '最小包裝',
  plMpq: '請輸入最小包裝',
  remark: '備註',
  plRemark: "請輸入備註",
  plRemarkMax: '內容不得超過{{ length }}',
  priceIndex: '商品價格{{ index }}',
  priceCount: '數量',
  plPriceCountIndex: '階梯價{{ index }}的數量是必填項',
  plPriceCount: '請輸入階梯數量',
  plPriceItemIndex: '階梯價{{ index }}的含稅單價是必填項',
  plPriceIndex: '請輸入對應的含稅單價',
  plPriceAdd: '添加階梯價',
  purchaseType: '採購類型',
  plPurchaseType: '請選擇採購類型',
  plSupplier: '請選擇供應商',
  plProduct: '請選擇商品與價格',
  plProductPrice: '請選擇商品與價格，輸入名稱可進行搜索',
  supplier: '供應商信息',
  productCount: '商品數量',
  plProductCount: '請輸入商品數量',
  scheduledOrderTime: '預計下單時間',
  plScheduledOrderTime: '請選擇預計下單時間',
  deliveryDeadline: '要求送貨時間',
  plDeliveryDeadline: '請選擇要求送貨時間',
  estimateArrivalAt: '預計送達時間',
  plEstimateArrivalAt: '請選擇預計送達時間',
  deliveredQuantity: '累計送達數量',
  plDeliveredQuantity: '請選擇已送達數量',
  productDesc: '商品單品備註',
  plProductDesc: '請輸入商品單品備註',
  orderDesc: '訂單備註',
  plOrderDesc: '請輸入訂單備註',
  productInfo: '商品信息',
  orderNotExisted: "採購訂單不存在",
  purchased: '已下單',
  notPurchase: '未下單',
  noPurOrder: '待採購',
  orderTime: '下單時間',
  supplierInfo: '供應商信息',
  orderList: '採購訂單列表',
  addPrice: "添加商品價格",
  bySearchPrice: "通過存貨編碼、存貨名稱、產品型號進行搜索",
  bySearchSupplier: '通過供應商編碼、供應商名稱、供應商簡稱、地址進行搜索',
  orderNumber: '訂單編號',
  purNo: '採購單號',
  orderState: '下單狀態',
  type: '採購類型',
  count: '採購數量',
  amount: '未稅總價',
  rateAmount: '含稅總價',
  priceDetail: "價格信息",
  printedTip: "該訂單已打印哦",
  printSelectTip: "請至少選擇一條數據進行打印",
  orderNum: "訂單編號",
  orderTime1: "訂單日期",
  currency: "結算幣種",
  demandNum: "需求單號",
  quantity: "數量",
  priceTax: "含稅單價",
  totalPrice: "價稅合計",
  deliveryTime: "交貨日期",
  total: "合計",
  purchase: "採購",
  review: "審核",
  signature: "廠商回簽",
  createTime: "創建日期",
  reviewTime: "審核日期",
  sigTime: "回簽日期",
  notSelect: "無法選中",
  selectPurError: "請選擇供應商相同的採購訂單",
  selectCurrencyError: "請選擇結算幣種相同的採購訂單",
  selectPayMethodError: "請選擇付款方式相同的採購訂單",
  addOrder: "添加訂單",
  searchCode: "通過存貨編碼進行搜索",
  supplierPrint: '供應商',
  currencyPoint: '結算幣種：',
  purchaseList: '採購訂單',
  pageIndex: '第 {{ index }} 頁 / 共 {{ total }} 頁',
  printReq: '生成採購文件',
  printRejectedFiltered: "已過濾已拒絕訂單",
  printRejectedFilteredDesc: "已自動過濾 {{rejectedCount}} 條已拒絕訂單，剩餘 {{validCount}} 條繼續生成採購文件。",
  printRejectedBlocked: "無法生成採購文件",
  printRejectedBlockedDesc: "所選訂單均為已拒絕訂單，請調整選擇後再試。",
  downloadFile: '點擊可以下載已經生成好的採購文件',
  successFile: '成功生成採購文件，正在喚起本地打印~',
  placeOrder: "下單",
  completed: "完成",
  plPlaceOrder: "你確定該筆訂單已下單嗎？",
  plPlaceOrders: "你確定這些訂單已下單嗎？",
  plOrderOk: "你確定該筆訂單已完結嗎？",
  plSeSupplier: "選擇供應商",
  plPlacePrice: "選擇下單價格",
  search: "搜索",
  clearFilters: "清空篩選",
  materialCode: "物料編碼",
  materialName: "物料名稱",
  materialModel: "物料型號",
  purCount: "採購數量",
  supplierTime: "齊料時間",
  addPurOrder: "一鍵生成採購單",
  addPurOrderTip: "自動生成採購訂單",
  roundMethod: "取整方式",
  roundNone: "不取整",
  roundDown: "向下取整",
  roundUp: "向上取整",
  roundNearest: "四捨五入",
  addPurSuccessTip: "一鍵生成採購單成功",
  addPurSuccessTipDesc: "總單數：{{all}}，生成採購單數量：{{suc}}",
  purConfirm: "採購確認",
  conPur: "確定採購",
  notPur: "暫不採購",
  purCurrency: "採購幣種",
  curr: "幣種",
  exchangeRateL: "匯率",
  purPrice: "價格",
  purPrice_1: "採購價",
  purPrice_2: "採購單價",
  all: "合計",
  supplierUserName: '供應商賬號名稱',
  supplierUser: '供應商賬號',
  supplierReset: '重置密碼',
  initPwd: '初始密碼',
  plSupplierUser: '請輸入供應商賬號',
  supplierUserAdd: '添加供應商賬號',
  supplierUserSearch: '通過賬號進行搜索',
  resetPwd: '密碼將重置為：{{ newPwd }}',
  resetPwdOk: '重置密碼成功',
  editPwdError: '密碼修改失敗',
  userList: '供應商賬戶列表',
  accounts: '供應商賬戶',
  ceil: "小計",
  addNoPurSuccess: "沒有新的採購訂單生成",
  printState: '打印狀態',
  unPrt: '未打印',
  supplierBatchNo: '供應商批次號',
  batchDeliveryNote: '批量送貨單',
  batchCompletedProduction: '批量完結',
  batchCompleteSummary: '已選擇 {{selected}} 條',
  batchCompleteNoAvailable: '當前選中項中沒有可完結的訂單',
  inventoryCode: '存貨編碼',
  supplierCode: '供應商編碼',
  supplierName: '供應商名稱',
  purchaseQuantity: '採購數量',
  supplierLot: '供應商批次號',
  plSupplierLot: '請輸入供應商批次號',
  pleaseSelect: '請至少選擇一條數據',
  pleaseSelectDeliveryTime: '請選擇送貨時間',
  pleaseInputDeliveryCount: "請輸入送貨數量和lot",
  leastOneMoreZero: "至少有一條送貨數量大於0且lot必填",
  pleaseInputSupplierLot: '請輸入供應商批次號',
  batchDeliverySuccess: '批量送貨單創建成功',
  plSupplierBatchNo: '請輸入供應商批次號',
  maxDeliveryQty: '可送貨數',
  noDeliveryData: '沒有可繼續生成採購單的數據',
  deliveryDate: '送貨時間',
  selectDeliveryDate: '請選擇送貨時間',
  prt: '已打印',
  isPrted: '是否已打印',
  payMethodPoint: "收付款協議名稱：",
  printCode: '料號',
  printName: '品名',
  printModel: '規格型號',
  spec: '規格',
  printUnit: '單位',
  printNum: '數量',
  printSPrice: '含稅單價',
  printPrce: '含稅金額',
  del: '作廢',
  delTips: '作廢提示',
  delContent: '你確定要作廢這個數據嗎？作廢後數據不可恢復！',
  state: '狀態',
  acceptType: '已接受',
  rejectType: '已拒絕',
  pend: '待處理',
  rejectDetail: '退回詳情',
  accept: '接受',
  reject: '拒絕',
  rejectDate: '退回時間',
  operationPerson: '操作人',
  rejectInformate: '退回信息',
  comfi: '確定接受採購單嗎？',
  ok: '確定',
  cancel: '取消',
  rejectComfi: '確定拒絕採購單嗎？',
  reOrder: '重新選擇供應商',
  operate: '操作',
  priced: "該商品已存在有效報價！",
  priceManage: '報價單審批',
  selectNumOver: "最多選擇10條！",
  onOk: '確定通過報價單嗎？',
  onReject: '確定拒絕報價單嗎？',
  payMethodName: '付款協議',
  helpAcc: '協助接受',
  sendTimePrint: '送貨日期',
  mobilePrint: '聯繫電話',
  recver: "聯絡人",
  seq: "序號",
  sendNum: "送貨批次號",
  outLot: "出庫批次",
  sendAddress: "交貨地址",
  printErr: "打印失敗",
  printDeliveryNote: "打印送貨單",
  phone1: "聯繫電話",
  orderDetail: "送貨單詳情",
  sendInfo: "送貨信息",
  delivery: '送貨單',
  deliveryNumber: '送貨單號',
  deliveryStatus: '完工狀態',
  updatePurchaseOrderStatus: '修改採購單狀態',
  purchaseOrderStatus: '採購單狀態',
  deliverable: '可送貨',
  notDeliverable: '不可送貨',
  inState: '到貨狀態',
  unArrived: '未到貨',
  partialIn: '部分到貨',
  allIn: '全部到貨',
  pendingProduction: '待生產',
  inProduction: '生產中',
  finishedProduction: '已完工',
  completedProduction: '完結',
  confirmCompletedProduction: '確定要完結此訂單嗎？',
  confirmBatchCompletedProduction: '確定要批量完結這批訂單嗎？',
  markAsFinished: '標記為完成',
  confirmFinish: '確定要完成此項目嗎？',
  complete: '完成',
  startProduction: '開始生產',
  markAsFinishedProduction: '標記為完工',
  confirmFinishProduction: '確定要將此項目標記為完工嗎？',
  confirmMarkAsInProduction: '確定標記為生產中嗎？',
  confirmMarkAsFinished: '確定標記為已完工嗎？',
  markAsInProduction: '標記為生產中',
  selectStatus: '選擇狀態',
  confirmMarkAsStatus: '確定標記為<strong>{{status}}</strong>嗎？',
  deliveryDatePlaceholder: '最晚送貨日期',
  notInStock: '未入庫',
  inStock: '已入庫',
  deliveryOrders: '已生成送貨單',
  goodName: '物料名稱',
  goodCode: '存貨編碼',
  goodModel: '型號',
  preInventory: '預入庫單',
  saveCodes: '保存條碼',
  clearCodes: '清空條碼',
  outOrder: '已生成出入庫單',
  isOut: '已出庫',
  notOut: '未出庫',
  hasPurOrder: '已生成採購單',
  outOrderNumber: '出庫單號',
  goodsExpiredAt: '物料有效期',
  plGoodsExpiredAt: '請輸入物料有效期',
  year: '年',
  helpAccSuc: '已幫助該供應商接受報價。',
  helpRejSuc: '已幫助該供應商拒絕報價。',
  noReq: '無法重新選擇供應商！',
  noReqDesc: '該採購訂單沒有問詢單，因此無法重新選擇供應商',
  equotationRequest: '問詢單狀態',
  receivingUnit: '送貨單位',
  receivingAddress: '交貨地址',
  deliveryProgress: '送貨單進度',
  zfed: "已作廢",
  mainCurPrice: "本位幣金額",
  billingDay: "帳期:",
  sendAdd: "送貨地址：",
  unRatePrice: "未稅單價",
  nilPur: "未生成",
  purState: "採購單狀態",
  sendAds: "送貨地址",
  sendAdsPl: "請選擇送貨地址",
  accer: "接收人",
  rePrt: "重新打印",
  rePrtCon: "確定重新打印嗎？",
  plRePrt: "請重新打印",
  onlyOneReq: "只能選擇同一需求單的訂單",
  multyDown: "批量下載",
  downErr: "下載失敗",
  leastOne: "至少選擇一條數據",
  inReturn: "已退庫",
  stocked: "是否已入庫",
  selectDateError: "只能選擇同一送貨時間的訂單",
  spareRate: "備品率(%)",
  spareRate_1: "備品率",
  spareRatePl: "請輸入備品率",
  spareCount: "備品數",
  spareCountPl: "請輸入備品數",
  cancelReturn: "取消退庫",
  reqPur: "需求清單/採購單",
  pdaPrint: "採購製單PDA打印",
  qcNum: "抽檢數",
  qcNo: "不良數",
  qcOk: "檢驗結果",
  qc: "核准",
  pg: "品管",
  cg: "倉管",
  outPrint: "出庫單打印",
  checkoutOrder: "驗收單",
  normalTemplate: "正常模版",
  warehouseTemplate: "倉儲模版",
  brand: "品牌",
  plBrand: "請輸入品牌",
  dictCurrency: "幣種",
  printSetting: "打印設置",
  otherInfo: "物料標籤",
  originalBrand: "物料原廠名稱",
  originalCode: "物料原廠代碼",
  mpn: "原廠代碼",
  plMpn: "請輸入原廠代碼",
  manufactureDate: "物料原廠生產週期",
  msdLevel: "物料MSD等級",
  dcc: "D/C",
  plShelfLife: "請輸入保質期",
  originPlace: "產地",
  netWeight: "淨重",
  grossWeight: "毛重",
  plOriginalBrand: "請輸入物料原廠名稱",
  plOriginalCode: "請輸入物料原廠代碼",
  plManufactureDate: "請輸入物料原廠生產週期",
  plMsdLevel: "請輸入物料MSD等級",
  plOriginPlace: "請輸入產地",
  plNetWeight: "請輸入淨重",
  plGrossWeight: "請輸入毛重",
  importSupplierPrice: '導入供應商價格',
  downloadPriceTemplate: '下載價格模版',
  importSuccess: '導入成功',
  importSuccessDesc: '成功導入 {{count}} 個物料的價格數據',
  importCompleted: '導入完成',
  importPartialDesc: '成功 {{success}} 個，失敗 {{failed}} 個（{{failedList}}）',
  fileParseError: '文件解析失敗，請檢查文件格式',
  templateWarningTitle: '注意',
  templateWarningIntro: '請注意價格模版的填寫規範:',
  templateWarning1: '1、可以一次性填寫多個物料，請保證物料編碼的準確性；',
  templateWarning2: '2、每個物料可以填寫多行數據，每個物料第一行數據為基準價格數據，數量不可以填寫，每個物料第二行及以後的數據為階梯價，填寫存貨編碼和含稅單價和數量即可；',
  templateWarning3: '3、請確保結算貨幣（可以不區分大小寫）在系統中存在；',
  templateWarning4: '4、請確保生效日期和失效日期字段值為8位數字，例如：20260309（2026年3月9日）；',
  templateWarning5: '5、如果數據填寫有誤可能會造成數據解析失敗或者導入信息有誤；',
  templateWarning6: '6、供應商編碼列必填；',
  iHaveKnown: '我已知悉',
  confirmOrder: '確定下單？',
  confirmOrderTip: '確認下單？',
  incompleteRecipientInfo: '收貨單位、收貨地址、聯絡人、聯絡電話等信息未完善。',
  pleaseCompleteRecipientInfo: '請完善收貨方數據',
  recipientInfoDetails: '收貨單位、收貨地址、聯絡人、聯絡電話',
  syncToSupplier: '同步供應商狀態',
  priceTemplateFileName: '供應商價格模板',
  excelHeaderInventoryCode: '存貨編碼',
  excelHeaderUnitPriceIncludingTax: '含稅單價',
  excelHeaderMaterialValidityPeriod: '物料有效期(年)',
  excelHeaderSupplyCycle: '供貨週期(天)',
  excelHeaderMinimumPackage: '最小包裝',
  excelHeaderQuantity: '數量',
  excelHeaderSettlementCurrency: '結算幣種',
  excelHeaderBrand: '品牌',
  excelHeaderMpn: '原廠代碼',
  excelHeaderShelfLife: 'D/C',
  supplierPrice: '供應商價格',
  supplierHisPrice: '供應商歷史價格',
  hisPriceExport: '歷史價格導出',
  allPriceHis: '全部歷史價格導出',
  generated: "已生成",
  importInbound: "導入生成送貨單",
  inboundTemplate: "送貨單導入模版",
  sendTime: "送貨日期",
  inboundTemplateTip1: "1、送貨日期必須填寫八位數字，例如20260311（2026年3月11日）",
  inboundTemplateTip2: "2、數量填寫該採購單的送貨數量",
  inboundTemplateTip3: "3、相同採購單號和相同送貨時間的記錄會合併，數量相加",
  inboundTemplateTip4: "4、數據填寫不合規可能會解析失敗，或導入不成功！",
  inboundTemplateTip5: "5、lot列可填可不填，如果不填則系統自動生成批次",
  noData: "沒有解析到數據",
  matchErr: "採購單數據匹配失敗，請重試！",
  importDone: "導入執行完畢",
  succNum: "成功個數",
  importErrTip: "以下採購單需要檢查數據",
  maxQuantityErr: "以下採購單總送貨量超出可送貨數量",
  excelCount: "總送貨數量",
  purNoErr: "第{{index}}行：採購單號校驗有誤",
  countErr: "第{{index}}行：送貨數量有誤",
  preTimeErr: "第{{index}}行：送貨時間有誤",
  importErr: "數據匹配失敗，沒有數據導入",
  notPurNo: '以下採購單不存在',
  numAdds: '數量合計',
  rateNumAdds: '含稅金額合計',
  ratePceAdds: '含稅單價合計',
  toReturn: "待退庫",
  returnQty: "退貨數量",
  actualArrivalQty: "實際到貨數量",
  actualArrivalTime: "實際到貨時間",
  undeliveredQty: "未交貨數量",
  orderNums: "送貨單數量",
  importSuppOrders: "導入生成供應商送貨單",
  allSendQty: "送貨總數量",
  sentQty: "已送貨數量",
  sendQty: "本次送貨數量",
  remainQTy: "剩餘送貨數量",
  noSendInfo: "沒有送貨信息",
  fileLoss: "導入源文件丟失！",
  import: "導入模版數據",
  matchPur: "匹配採購單",
  done: "完成",
  thdCode: "MES客戶編碼",
  plThdCode: "請輸入MES客戶編碼",
  batchSubmit: '批量報價',
  batchSubmitSucc: '批量報價成功',
  batchSubmitErr: '批量報價失敗',
  needPriceTip: '以下數據需要手動填寫價格',
  batchSubmitTip: '確定對所選擇的問詢單報價嗎？',
  actualInboundTime: "實際入庫時間",
  supplierCodeNeed: "第{{index}}行供應商編碼不存在，解析失敗",
  addRule: "是否添加 採購訂單交易條約 ？",
  effectiveAt: "生效日期",
  expiredAtEcl: "失效日期",
  effectiveAtPl: "請選擇生效日期",
  expiredAtEclPl: "請選擇失效日期",
  purOrderPl: "請選擇採購單",
  notApi: "該供應商沒有配置供應商Api，無法進行轉單！",
  swapData: "轉單數據",
  swapDone: "轉單完成",
  notSuppPros: "供應商系統中不存在這些商品，請去該供應商所在的系統中添加這些商品信息",
  notSaleProPrice: "供應商系統中不存在該終端客戶的客戶價格，請去該供應商的系統中添加這些客戶價格",
  purchaseTransferSuccess: "採購單轉單銷售單完成",
  noRejected: "改採購單已拒絕，無法進行轉單！",
  swapErr: "轉單失敗",
  startSwap: "開始轉單",
  priceComputedTip: "商品數量或稅率發生變動，需要重新計算價格",
  selectPurErrorTip: "請選擇相同供應商、相同結算幣種、相同付款方式的條目",
  notResolved: "該採購單不是已接受狀態，無法選中",
  printedTipErr: "以下條目已打印，無法繼續打印",
  downloadTip: "PDF生成完畢，是否下載?",
  pdfIng: "正在生成PDF",
  addPurchaseOrder: "添加採購單",
  addItem: "添加訂單項",
  item: "訂單項",
  items: "訂單項",
  plCurrency: "請選擇幣種",
  plPayMethod: "請選擇付款方式",
  ladderPrice: "階梯價",
  ladderPriceCount: "數量",
  productType: "產品類型",
  brandName: "品牌名稱",
  brandModel: "品牌型號",
};

export default purchase;
